import LockIcon from '@mui/icons-material/Lock';
import LogoutIcon from '@mui/icons-material/Logout';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, getUserLogged } from 'src/utils/auth';
import { postAPI } from 'src/utils/api';
import { useDataSmall } from 'src/context/ContextDataSmall';
// import BtnGradient from '../common/button/BtnGradient';

const drawerWidth: number = 220;
const drawerCloseWidth: number = 80;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  system: string;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open, system }) => ({
  marginLeft: drawerCloseWidth,
  width: system === 'new' ? `calc(100% - ${drawerCloseWidth}px)` : '100%',
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: system === 'new' ? `calc(100% - ${drawerWidth}px)` : '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const menuUserStyle = {
  p: '6px 15px 6px 16px',
  minWidth: '36px',
  borderRadius: '4px',
  '&.MuiListItem-root.active': { backgroundColor: '#E8F8FF' },
  '&.MuiListItem-root:hover': { backgroundColor: '#E8F8FF' },
  cursor: 'pointer',
}

type HeaderProps = {
  open: boolean;
  system: boolean;
  handleSwitchSystem: () => void
};

const Header: React.FC<HeaderProps> = (props) => {
  const dataSmallContext = useDataSmall();
  const navigate = useNavigate();
  const userLogin = getUserLogged();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    setAnchorElUser(null);
    window.localStorage.setItem('auth_data', '');
    window.localStorage.setItem('auth_token', '');

    window.localStorage.removeItem('karte_permission')
    window.localStorage.removeItem('__user')
    window.localStorage.removeItem('karte_token')
    
    window.sessionStorage.removeItem('karte_permission')
    window.sessionStorage.removeItem('__user')
    window.sessionStorage.removeItem('karte_token')
    navigate('/login');
  };

  const handleChangePassword = () => {
    navigate('/user/change-password')
  }
  const getPayments = async (page: number) => {
    try {
      const token = getToken();

      if (!token) {
        // throw new Error('Failed to get access token');
        return;
      }

      postAPI(`/patient/search?token=${token}`, {
        page: page,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            const totalPayments = res.data.payments.length + res.data.unpayments.length;
            dataSmallContext.setBadgeCountPayment(totalPayments);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getPayments(1);
    // eslint-disable-next-line
  }, []);

  return (
    <AppBar
      position='absolute'
      open={props.open}
      system={props.system ? 'old' : 'new'}
      sx={{
        backgroundColor: 'primary.light',
        boxShadow: 'none',
        borderBottom: '1px solid #f3f3f3'
      }}
    >
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
          minHeight: { xs: '56px' },
        }}
      >
        <Typography
          component='h1'
          variant='h6'
          color='primary.dark'
          noWrap
          fontSize={'12px'}
          fontWeight={500}
          sx={{ flexGrow: 1 }}
        >
          リゾナスフェイスクリック東京
        </Typography>
        {/* Hide unuse menu as of now */}
        {/* <IconButton color='inherit'>
          <Badge
            badgeContent={storeContext.notifications.length}
            sx={{
              color: 'primary.light',
              '& .MuiBadge-badge': { backgroundColor: 'red' },
            }}
          >
            <Box
              component={'img'}
              src={`/images/icons/ic-notification.svg`}
              alt='Logo'
            />
          </Badge>
        </IconButton>
        <IconButton color='inherit'>
          <Box
            component={'img'}
            src={`/images/icons/ic-print.svg`}
            alt='Print'
          />
        </IconButton>
        <TextField
          id='outlined-start-adornment'
          autoComplete='one-time-code'
          placeholder='フリーワード検索'
          sx={{
            m: 1,
            width: '240px',
            height: '32px',
            '& .MuiInputBase-root': {
              borderRadius: '60px',
            },
            '& .MuiInputBase-input': { py: '4px' },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Box
                  component={'img'}
                  src={`/images/icons/ic-search.svg`}
                  alt='search'
                />
              </InputAdornment>
            ),
          }}
        /> */}
        <Stack direction={'row'} spacing={'20px'}>
          {/* <BtnGradient text='Switch System' width='150px' handleButtonClick={props.handleSwitchSystem}/> */}
          <Stack
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{ cursor: 'pointer' }}
            onClick={handleOpenUserMenu}
          >
            <Avatar
              alt={userLogin ? userLogin.user.name : ''}
              src='/images/avatar/1.jpg'
              sx={{ width: '32px', height: '32px' }}
            />
            <Stack ml={'8px'}>
              <Typography fontSize={'12px'} fontWeight={700} color={'#434154'}>
                {userLogin ? userLogin.user.name : ''}
              </Typography>
            </Stack>
          </Stack>
          <Popover
            id={'user-menu'}
            open={Boolean(anchorElUser)}
            anchorEl={anchorElUser}
            onClose={handleCloseUserMenu}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: -40,
              horizontal: 'right',
            }}
          >
            <List component='div' disablePadding>
              <ListItem
                sx={menuUserStyle}
                onClick={handleChangePassword}
              >
                <ListItemIcon sx={{ minWidth: '36px' }}>
                  <LockIcon sx={{ mr: '8px' }} />
                </ListItemIcon>
                <ListItemText primary={'パスワード'} />
              </ListItem>
              <ListItem
                sx={menuUserStyle}
                onClick={handleLogout}
              >
                <ListItemIcon sx={{ minWidth: '36px' }}>
                  <LogoutIcon sx={{ mr: '8px' }} />
                </ListItemIcon>
                <ListItemText primary={'ログアウト'} />
              </ListItem>
            </List>
          </Popover>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
